import { createAction } from '@reduxjs/toolkit'
import { CreationFileRequirement } from '@ads/front-core/interfaces'
import { RootState } from '../../rootState'

export const setCreationFileRequirements = createAction<
  CreationFileRequirement[]
>('setCreationFileRequirements')

export const setCreationFileRequirementsReducer = (
  state: RootState['app'],
  action: ReturnType<typeof setCreationFileRequirements>,
): void => {
  state.creationFileRequirements = action.payload
}
